type LogProvider = {
  logError: (err: Error | string, additional?: { [key: string]: any }) => void;
  logInfo: (message: string, additional?: { [key: string]: any }) => void;
};

let provider: LogProvider | undefined;

export function setLogProvider(
  p: LogProvider = {
    logError: err => {
      console.log(err);
    },
    logInfo: (message, additional) => {
      console.info(message, additional);
    },
  },
) {
  provider = p;
}

export function logError(err: Error | string, additional?: { [key: string]: any }) {
  provider?.logError(err, additional);
}

if (__BROWSER__) {
  (window as any).__exciteLogError = logError;
}

export async function logInfo(message: string, additional?: { [key: string]: any }) {
  provider?.logInfo(message, additional);
}

export function logUncaughtErrors() {
  if (__BROWSER__) {
    const prevOnError = window.onerror;
    window.onerror = (msg, url, lineNo, columnNo, error) => {
      logError(error ?? msg.toString());

      if (prevOnError) {
        return prevOnError.apply(window, [msg, url, lineNo, columnNo, error]);
      }
    };
  }
}
